import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import { useModel as _useModel, mergeModels as _mergeModels } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = {
  class: "tabs-nav"
};
var _hoisted_2 = ["onClick"];
var _hoisted_3 = ["src"];
import { toRefs } from 'vue';
export default {
  __name: 'TabNav',
  props: /*@__PURE__*/_mergeModels({
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    currentIndex: {
      type: Number,
      default: 0
    }
  }, {
    "currentIndex": {
      type: Number,
      default: 0
    },
    "currentIndexModifiers": {}
  }),
  emits: /*@__PURE__*/_mergeModels(['change'], ["update:currentIndex"]),
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emit = __emit;
    var _toRefs = toRefs(props),
      items = _toRefs.items;
    var currentIndex = _useModel(__props, 'currentIndex');
    /**
     * 获取图标名称
     */
    var iconName = function iconName(item, index) {
      var active = currentIndex.value === index;
      // `nav-${item.icon}${active ? '-active' : ''}`
      return require("@/assets/home/nav-".concat(item.icon).concat(active ? '-active' : '', ".svg"));
    };
    /**
     * 点击切换
     */
    var handleClick = function handleClick(index) {
      currentIndex.value = index;
      emit('change', items[index]);
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("ul", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items), function (item, index) {
        return _openBlock(), _createElementBlock("li", {
          key: index,
          class: _normalizeClass(['nav-item', currentIndex.value === index ? 'nav-active' : '']),
          onClick: function onClick($event) {
            return handleClick(index);
          }
        }, [_createElementVNode("img", {
          src: iconName(item, index)
        }, null, 8, _hoisted_3), _createElementVNode("span", null, _toDisplayString(item.name), 1)], 10, _hoisted_2);
      }), 128))]);
    };
  }
};